import React, { Component } from "react";
import Router from "./Router";
import { createBrowserHistory } from "history";

import "assets/styles/typography.css";
import "assets/styles/layout.css";

class App extends Component {
  constructor(props) {
    super(props);
    // Initialize history once to prevent mismatches
    this.history = createBrowserHistory();
  }

  render() {
    return (
      <div className="app-shell">
        <Router history={this.history} />
      </div>
    );
  }
}

export default App;
